import React from 'react';
import { Link } from 'react-router';
import { mapZipToDetailLocation, mapType, getThousandSeperatedNumber } from '../../common/app/helperFunctions';
import { FilledButton } from '../app/components';
import './styles.css';

class Property extends React.Component {
  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  editProperty = (e) => {
    const { from, property } = this.props;
    e.preventDefault();

    this.context.router.transitionTo({
      pathname: `/editProperty/${property.id}`,
      state: { from },
    });
  }

  render() {
    const {
      from, viewer, property, presentational,
      deactivateProperty, activateProperty,
    } = this.props;

    return (
      <Link
        className={`property${!property.active ? ' inactive' : ''}`}
        to={{
          pathname: presentational ? '#' : `/properties/${property.id}`,
          state: { from },
        }}
      >
        <div className="content">
          <div className="image-wrapper">
            {(viewer && (viewer.id === property.ownerId)) &&
              <div className="quick-options">
                <img className="avatar" role="presentation" src={viewer ? viewer.photoURL : ''} />
                <FilledButton
                  className="no-icon"
                  content={<p>Breyta auglýsingu</p>}
                  disabled={false}
                  color={property.active ? '#00e39a' : '#FBAD36'}
                  backgroundColor="#ffffff"
                  onClick={this.editProperty}
                />
                <FilledButton
                  className="no-icon"
                  content={property.active ? <p>Óvirkja auglýsingu</p> : <p>Virkja auglýsingu</p>}
                  disabled={false}
                  flat
                  color="#ffffff"
                  backgroundColor="transparent"
                  onClick={property.active ?
                    e => deactivateProperty(e, property.id) :
                    e => activateProperty(e, property.id)
                  }
                />
              </div>
            }
            <img role="presentation" src={presentational ? property.imageDownloadUrls[0].value : property.imageDownloadUrls[0].url} />
          </div>
          <div className="address-wrapper">
            <span className="address">{property.address}</span>
            <span className="price">{getThousandSeperatedNumber(property.price)} <span>kr</span></span>
          </div>
          <div className="info-wrapper">
            <span>{property.zip} <span>{mapZipToDetailLocation(property.zip)} / </span></span>
            <span>{mapType(property.type)}<span> / </span></span>
            {property.bedrooms !== 0 &&
              <span>{property.bedrooms} <span>svefnherbergi / </span></span>
            }
            <span>{getThousandSeperatedNumber(property.size)} <span>fm</span></span>
          </div>
        </div>
      </Link>
    );
  }
}

Property.propTypes = {
  from: React.PropTypes.string,
  viewer: React.PropTypes.object,
  property: React.PropTypes.object.isRequired,
  presentational: React.PropTypes.bool.isRequired,
  deactivateProperty: React.PropTypes.func,
  activateProperty: React.PropTypes.func,
};

export default Property;



// WEBPACK FOOTER //
// ./src/browser/properties/Property.js